/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Method_MoreInputs */

const vi_payment_method_more = /** @type {(inputs: Payment_Method_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hình thức thanh toán khác`)
};

/**

* @param {Payment_Method_MoreInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const payment_method_more = /** @type {((inputs?: Payment_Method_MoreInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Method_MoreInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_payment_method_more(inputs)
});